import moment from "moment"

import {createIntl, createIntlCache} from "@formatjs/intl"
import { Toast } from "./toasts";


const languages = {
  en: {
    error: "Sorry, something has gone wrong.",
    utility_with: "with",
    utility_to: "to",
    utility_save: "Save",
    utility_cancel: "Cancel",
    consumer_locations_title: "Select Location",
    consumer_location_title: "View Location",
    consumer_services_title: "Select Service",
    consumer_resources_title: "Select Resource",
    consumer_appointments_title: "Select Appointment",
    consumer_search_locations: "Search Locations...",
    consumer_search_services: "Search Services...",
    consumer_search_resources: "Search Resources...",
    consumer_search_appointments: "Search Appointments...",
    consumer_availability_none: "Sorry, no availability exists for this time period.",
    consumer_availability_title: "Select Date & Time",
    consumer_availability_month_jan: "January",
    consumer_availability_month_feb: "February",
    consumer_availability_month_mar: "March",
    consumer_availability_month_apr: "April",
    consumer_availability_month_may: "May",
    consumer_availability_month_jun: "June",
    consumer_availability_month_jul: "July",
    consumer_availability_month_aug: "August",
    consumer_availability_month_sep: "September",
    consumer_availability_month_oct: "October",
    consumer_availability_month_nov: "November",
    consumer_availability_month_dec: "December",
    consumer_availability_weekday_sun: "Sunday",
    consumer_availability_weekday_mon: "Monday",
    consumer_availability_weekday_tue: "Tuesday",
    consumer_availability_weekday_wed: "Wednesday",
    consumer_availability_weekday_thu: "Thursday",
    consumer_availability_weekday_fri: "Friday",
    consumer_availability_weekday_sat: "Saturday",
    consumer_availability_time_of_day_morning: "Morning",
    consumer_availability_time_of_day_afternoon: "Afternoon",
    consumer_availability_time_of_day_evening: "Evening",
    consumer_availability_booking_form_title: "Complete booking",
    consumer_availability_booking_form_expired: "The appointment has expired, please select a new time.",
    consumer_availability_booking_form_expiration: "will expire in",
    consumer_availability_booking_form_minutes: "minutes",
    consumer_availability_booking_form_firstName: "First Name",
    consumer_availability_booking_form_lastName: "Last Name",
    consumer_availability_booking_form_email: "Email",
    consumer_availability_booking_form_phone: "Phone",
    consumer_availability_booking_form_customerMessage: "Leave a message",
    consumer_availability_booking_form_submit: "Submit",
    consumer_availability_booking_form_cancel: "Cancel",
    consumer_availability_booking_form_confirmation: "Your appointment has been booked.",
    consumer_availability_booking_form_reschedule_confirmation: "Your appointment has been rescheduled.",
    consumer_availability_booking_form_sms: "Notify me by text message",
    consumer_appointment_detail: "{serviceName} with {resourceName}",  
    consumer_appointment_duration: "{duration} min",  
    location_title: "View Location",
    location_not_found: "No Location was found.",
    setup_locationSetup_title: "Setup Location",
    setup_locationSetup_confirmation: "Your Location has been setup successfully.",
    setup_locationSetup_form_name: "Location Name",
    setup_locationSetup_form_timezone: "Timezone",
    setup_locationSetup_form_book: "Book",
    setup_locationSetup_form_addressLine1: "Address",
    setup_locationSetup_form_addressLine2: "Address Line 2",
    setup_locationSetup_form_email: "Email",
    setup_locationSetup_form_website: "Website",
    setup_locationSetup_form_city: "City",
    setup_locationSetup_form_state: "State/Province",
    setup_locationSetup_form_postalCode: "ZIP/PostalCode",
    setup_locationSetup_form_bookAheadUnit: "Book Ahead",
    setup_locationSetup_form_bookAheadValue: "Book Ahead",
    setup_locationSetup_form_bookInAdvance: "Book In Advance",
    setup_locationSetup_form_availability: "Availability",
    setup_locationSetup_form_blocks: "Blocks",
    setup_locationSetup_form_blocks_btn1: "Add Date/Time Block",
    setup_locationSetup_form_allocations_btn1: "Add Available Date/Time",
    setup_locationSetup_form_allocations_btn1_desc: "Open availability for a particular date and time, which may be repeated until a specified end date.",
    setup_locationSetup_form_blocks_btn2: "Create",
    setup_resourceSetup_title: "Setup Resource",
    setup_resourceSetup_confirmation: "Your Resource has been setup successfully.",
    setup_resourceSetup_form_name: "Resource Name",
    setup_resourceSetup_form_timezone: "Timezone",
    setup_resourceSetup_form_groupId: "Group",
    setup_resourceSetup_form_addressLine1: "Address",
    setup_resourceSetup_form_addressLine2: "Address Line 2",
    setup_resourceSetup_form_email: "Email",
    setup_resourceSetup_form_website: "Website",
    setup_resourceSetup_form_city: "City",
    setup_resourceSetup_form_state: "State/Province",
    setup_resourceSetup_form_select_state: "Select State/Province",
    setup_resourceSetup_form_country: "Country",
    setup_resourceSetup_form_select_country: "Country",
    setup_resourceSetup_form_postalCode: "ZIP/PostalCode",
    setup_resourceSetup_form_conferenceInfo: "Conference Info",
    setup_resourceSetup_form_bookAheadUnit: "Book Ahead",
    setup_resourceSetup_form_bookAheadValue: "Book Ahead",
    setup_resourceSetup_form_bookInAdvance: "Book In Advance",
    setup_resourceSetup_form_availability: "Availability",
    setup_resourceSetup_form_blocks: "Blocks",
    setup_resourceSetup_form_blocks_btn1: "Block Date/Time",
    setup_resourceSetup_form_blocks_btn2: "Create",
    setup_resourceSetup_form_allocations_start_label: "Starting",
    setup_resourceSetup_form_allocations_end_label: "Ending",
    setup_resourceSetup_form_allocations_from_label: "From",
    setup_resourceSetup_form_allocations_to_label: "To",
    setup_resourceSetup_form_allocations_repeat_label: "Repeat",
    setup_resourceSetup_form_allocations_repeats_label: "Repeats",
    setup_resourceSetup_form_allocations_every_label: "Every",
    setup_resourceSetup_form_allocations_on_label: "On",
    setup_resourceSetup_form_allocations_daily_label: "Daily",
    setup_resourceSetup_form_allocations_weekly_label: "Weekly",
    setup_resourceSetup_form_allocations_monthly_label: "Monthly",
    setup_serviceSetup_confirmation: "Your Service has been setup successfully.",
    setup_serviceSetup_title: "Setup Service",
    setup_serviceSetup_form_name: "Service Name",
    setup_serviceSetup_form_type: "Type",
    setup_serviceSetup_form_duration: "Duration",
    setup_serviceSetup_form_feeAmount: "Fee Amount",
    setup_serviceSetup_form_variableDuration: "Variable Duration",
    setup_serviceSetup_form_durationMin: "Minimum Duration",
    setup_serviceSetup_form_durationMax: "Maximum Duration",
    setup_serviceSetup_form_durationInterval: "Duration Interval",
    no_language: "Sorry, translation for this language does not yet exist.",
    allocation_item_repeats_D: 'Daily',
    allocation_item_repeats_W: 'Weekly',
    allocation_item_repeats_M: 'Monthly',
  },
  es: {
    error: "Lo sentimos, algo ha ido mal.",
    utility_with: "con",
    utility_to: "a",
    utility_save: "Guardar",
    utility_cancel: "Cancelar",
    consumer_locations_title: "Seleccionar Ubicación",
    consumer_location_title: "Ver ubicación",
    consumer_services_title: "Seleccionar Servicio",
    consumer_resources_title: "Seleccionar Recurso",
    consumer_appointments_title: "Seleccionar Cita",
    consumer_search_locations: "Buscar Ubicaciones...",
    consumer_search_services: "Servicios de Búsqueda...",
    consumer_search_resources: "Buscar Recursos...",
    consumer_search_appointments: "Buscar Citas...",
    consumer_availability_none: "Lo sentimos, no existe disponibilidad para este período de tiempo.",
    consumer_availability_title: "Seleccionar Fecha y Hora",
    consumer_availability_month_jan: "Enero",
    consumer_availability_month_feb: "Febrero",
    consumer_availability_month_mar: "Marzo",
    consumer_availability_month_apr: "Abril",
    consumer_availability_month_may: "Mayo",
    consumer_availability_month_jun: "Junio",
    consumer_availability_month_jul: "Julio",
    consumer_availability_month_aug: "Agosto",
    consumer_availability_month_sep: "Septiembre",
    consumer_availability_month_oct: "Octubre",
    consumer_availability_month_nov: "Noviembre",
    consumer_availability_month_dec: "Diciembre",
    consumer_availability_weekday_sun: "Dom",
    consumer_availability_weekday_mon: "Lun",
    consumer_availability_weekday_tue: "Mar",
    consumer_availability_weekday_wed: "Mié",
    consumer_availability_weekday_thu: "Jue",
    consumer_availability_weekday_fri: "Vie",
    consumer_availability_weekday_sat: "Sáb",
    consumer_availability_time_of_day_morning: "Mañana",
    consumer_availability_time_of_day_afternoon: "Tarde",
    consumer_availability_time_of_day_evening: "Noche",
    consumer_availability_booking_form_title: "Reserva Completa",
    consumer_availability_booking_form_expired: "La cita ha caducado, seleccione un nuevo horario.",
    consumer_availability_booking_form_expiration: "vencerá en",
    consumer_availability_booking_form_minutes: "minutos",
    consumer_availability_booking_form_firstName: "Nombre de pila",
    consumer_availability_booking_form_lastName: "Apellido",
    consumer_availability_booking_form_email: "Correo electrónico",
    consumer_availability_booking_form_phone: "Teléfono",
    consumer_availability_booking_form_customerMessage: "Dejar un mensaje",
    consumer_availability_booking_form_submit: "Entregar",
    consumer_availability_booking_form_cancel: "Cancelar",
    consumer_availability_booking_form_confirmation: "Tu cita ha sido reservada.",
    consumer_availability_booking_form_reschedule_confirmation: "Su cita ha sido reprogramada.",
    consumer_availability_booking_form_sms: "Notificarme por mensaje de texto",
    consumer_appointment_detail: "{serviceName} con {resourceName}",  
    consumer_appointment_duration: "{duration} min",  
    location_title: "Ver ubicación",
    location_not_found: "No se encontró ninguna ubicación.",
    setup_locationSetup_title: "Ubicación de Instalación",
    setup_locationSetup_confirmation: "Su ubicación se ha configurado correctamente.",
    setup_locationSetup_form_name: "Nombre del lugar",
    setup_locationSetup_form_timezone: "Zona Horaria",
    setup_locationSetup_form_book: "Cronograma",
    setup_locationSetup_form_addressLine1: "Dirección Línea 1",
    setup_locationSetup_form_addressLine2: "Dirección Línea 2",
    setup_locationSetup_form_email: "Correo electrónico",
    setup_locationSetup_form_website: "Sitio web",
    setup_locationSetup_form_city: "Ciudad",
    setup_locationSetup_form_state: "Provincia",
    setup_locationSetup_form_postalCode: "Código postal",
    setup_locationSetup_form_bookAheadUnit: "Reservar con antelación",
    setup_locationSetup_form_bookAheadValue: "Reservar con antelación",
    setup_locationSetup_form_bookInAdvance: "Reservar con antelación",
    setup_locationSetup_form_availability: "Disponibilidad",
    setup_locationSetup_form_blocks: "Bloques",
    setup_locationSetup_form_blocks_btn1: "Bloquear Fecha/Hora",
    setup_locationSetup_form_allocations_btn1: "Agregar Fecha/Hora Disponible",
    setup_locationSetup_form_allocations_btn1_desc: "Disponibilidad abierta para una fecha y hora en particular, que puede repetirse hasta una fecha de finalización especificada.",
    setup_locationSetup_form_blocks_btn2: "Crear",
    setup_resourceSetup_title: "Ubicación de Instalación",
    setup_resourceSetup_confirmation: "Su ubicación se ha configurado correctamente.",
    setup_resourceSetup_form_name: "Nombre del lugar",
    setup_resourceSetup_form_group: "Grupo",
    setup_resourceSetup_form_addressLine1: "Dirección Línea 1",
    setup_resourceSetup_form_addressLine2: "Dirección Línea 2",
    setup_resourceSetup_form_email: "Correo electrónico",
    setup_resourceSetup_form_website: "Sitio web",
    setup_resourceSetup_form_city: "Ciudad",
    setup_resourceSetup_form_state: "Provincia",
    setup_resourceSetup_form_select_state: "Seleccionar provincia",
    setup_resourceSetup_form_country: "País",
    setup_resourceSetup_form_select_country: "Seleccionar país",
    setup_resourceSetup_form_postalCode: "Código postal",
    setup_resourceSetup_form_conferenceInfo: "URL de la conferencia",
    setup_resourceSetup_form_bookAheadUnit: "Reservar con antelación",
    setup_resourceSetup_form_bookAheadValue: "Reservar con antelación",
    setup_resourceSetup_form_bookInAdvance: "Reservar con antelación",
    setup_resourceSetup_form_availability: "Disponibilidad",
    setup_resourceSetup_form_blocks: "Bloques",
    setup_resourceSetup_form_blocks_btn1: "Bloquear Fecha/Hora",
    setup_resourceSetup_form_blocks_btn2: "Crear",
    setup_resourceSetup_form_allocations_start_label: "A partir de",
    setup_resourceSetup_form_allocations_end_label: "Finalizando",
    setup_resourceSetup_form_allocations_from_label: "De",
    setup_resourceSetup_form_allocations_to_label: "A",
    setup_resourceSetup_form_allocations_repeat_label: "Repetir",
    setup_resourceSetup_form_allocations_repeats_label: "Se repite",
    setup_resourceSetup_form_allocations_every_label: "Cada",
    setup_resourceSetup_form_allocations_on_label: "En",
    setup_resourceSetup_form_allocations_daily_label: "A diario",
    setup_resourceSetup_form_allocations_weekly_label: "Semanalmente",
    setup_resourceSetup_form_allocations_monthly_label: "Mensual",
    setup_serviceSetup_confirmation: "Su Servicio se ha configurado correctamente.",
    setup_serviceSetup_form_name: "Nombre del Servicio",
    setup_serviceSetup_form_type: "Tipo",
    setup_serviceSetup_form_duration: "Duración",
    setup_serviceSetup_form_feeAmount: "Importe de la Cuota",
    setup_serviceSetup_form_variableDuration: "Duración Variable",
    setup_serviceSetup_form_durationMin: "Duración mínima",
    setup_serviceSetup_form_durationMax: "Duración máxima",
    setup_serviceSetup_form_durationInterval: "Intervalo de duración",
    no_language: "Lo sentimos, la traducción para este idioma aún no existe.",
    asignación_item_repeats_D: 'Diario',
    asignación_item_repeats_W: 'Semanalmente',
    asignación_item_repeats_M: 'Mensual',
  },
  fr: {
    error: "Désolé, quelque chose s'est mal passé.",
    utility_with: "avec",
    utility_to: "à",
    utility_save: "Annuler",
    utility_to: "Économiser",
    consumer_locations_title: "Sélectionnez l'emplacement",
    consumer_location_title: "Voir l'emplacement",
    consumer_services_title: "Sélectionnez un service",
    consumer_resources_title: "Sélectionner une ressource",
    consumer_appointments_title: "Sélectionnez un rendez-vous",
    consumer_search_locations: "Rechercher des emplacements...",
    consumer_search_services: "Services de recherche...",
    consumer_search_resources: "Rechercher des ressources...",
    consumer_search_appointments: "Rechercher des rendez-vous...",
    consumer_availability_none: "Désolé, aucune disponibilité n'existe pour cette période.",
    consumer_availability_title: "Sélectionnez la date et l'heure",
    consumer_availability_month_jan: "Janvier",
    consumer_availability_month_feb: "Février",
    consumer_availability_month_mar: "Mars",
    consumer_availability_month_apr: "Avril",
    consumer_availability_month_may: "Peut",
    consumer_availability_month_jun: "Juin",
    consumer_availability_month_jul: "Juillet",
    consumer_availability_month_aug: "Août",
    consumer_availability_month_sep: "Septembre",
    consumer_availability_month_oct: "Octobre",
    consumer_availability_month_nov: "Novembre",
    consumer_availability_month_dec: "Décembre",
    consumer_availability_weekday_sun: "Dimanche",
    consumer_availability_weekday_mon: "Lundi",
    consumer_availability_weekday_tue: "Mardi",
    consumer_availability_weekday_wed: "Mercredi",
    consumer_availability_weekday_thu: "Jeudi",
    consumer_availability_weekday_fri: "Vendredi",
    consumer_availability_weekday_sat: "Samedi",
    consumer_availability_time_of_day_morning: "Matin",
    consumer_availability_time_of_day_afternoon: "Après-midi",
    consumer_availability_time_of_day_evening: "Soirée",
    consumer_availability_booking_form_title: "Réservation complète",
    consumer_availability_booking_form_expired: "Le rendez-vous est expiré, veuillez sélectionner une nouvelle heure.",
    consumer_availability_booking_form_expiration: "expirera dans",
    consumer_availability_booking_form_minutes: "minutes",
    consumer_availability_booking_form_firstName: "Prénom",
    consumer_availability_booking_form_lastName: "Nom de famille",
    consumer_availability_booking_form_email: "E-mail",
    consumer_availability_booking_form_phone: "Téléphone",
    consumer_availability_booking_form_customerMessage: "Laisser un message",
    consumer_availability_booking_form_submit: "Soumettre",
    consumer_availability_booking_form_cancel: "Annuler",
    consumer_availability_booking_form_confirmation: "Votre rendez-vous a été réservé.",
    consumer_availability_booking_form_reschedule_confirmation: "Votre rendez-vous a été reporté.",
    consumer_availability_booking_form_sms: "Prévenez-moi par SMS",
    consumer_appointment_detail: "{serviceName} avec {resourceName}",  
    consumer_appointment_duration: "{durée} minutes",  
    location_title: "Voir l'emplacement",
    location_not_found: "Aucun emplacement n'a été trouvé.",
    setup_locationSetup_title: "Emplacement d'installation",
    setup_locationSetup_confirmation: "Votre emplacement a été configuré avec succès.",
    setup_locationSetup_form_name: "Nom de la localisation",
    setup_locationSetup_form_timezone: "Fuseau horaire",
    setup_locationSetup_form_book: "Livre",
    setup_locationSetup_form_addressLine1: "Adresse",
    setup_locationSetup_form_addressLine2: "Adresse Ligne 2",
    setup_locationSetup_form_email: "E-mail",
    setup_locationSetup_form_website: "Site web",
    setup_locationSetup_form_city: "Ville",
    setup_locationSetup_form_state: "État/Province",
    setup_locationSetup_form_postalCode: "Zip / code postal",
    setup_locationSetup_form_bookAheadUnit: "Réserver à l'avance",
    setup_locationSetup_form_bookAheadValue: "Réserver à l'avance",
    setup_locationSetup_form_bookInAdvance: "Réserver à l'avance",
    setup_locationSetup_form_availability: "Disponibilité",
    setup_locationSetup_form_blocks: "Blocs",
    setup_locationSetup_form_blocks_btn1: "Ajouter un bloc de date/heure",
    setup_locationSetup_form_allocations_btn1: "Ajouter une date/heure disponible",
    setup_locationSetup_form_allocations_btn1_desc: "Disponibilité ouverte pour une date et une heure particulières, qui peuvent être répétées jusqu'à une date de fin spécifiée.",
    setup_locationSetup_form_blocks_btn2: "Créer",
    setup_resourceSetup_title: "Ressource de configuration",
    setup_resourceSetup_confirmation: "Votre ressource a été configurée avec succès.",
    setup_resourceSetup_form_name: "Nom de la ressource",
    setup_resourceSetup_form_timezone: "Fuseau horaire",
    setup_resourceSetup_form_groupId: "Groupe",
    setup_resourceSetup_form_addressLine1: "Adresse",
    setup_resourceSetup_form_addressLine2: "Adresse Ligne 2",
    setup_resourceSetup_form_email: "E-mail",
    setup_resourceSetup_form_website: "Site web",
    setup_resourceSetup_form_city: "Ville",
    setup_resourceSetup_form_state: "État/Province",
    setup_resourceSetup_form_select_state: "Choisissez le État/Province",
    setup_resourceSetup_form_country: "Pays",
    setup_resourceSetup_form_select_country: "Choisissez le pays",
    setup_resourceSetup_form_postalCode: "Zip / code postal",
    setup_resourceSetup_form_conferenceInfo: "Informations sur la conférence",
    setup_resourceSetup_form_bookAheadUnit: "Réserver à l'avance",
    setup_resourceSetup_form_bookAheadValue: "Réserver à l'avance",
    setup_resourceSetup_form_bookInAdvance: "Réserver à l'avance",
    setup_resourceSetup_form_availability: "Disponibilité",
    setup_resourceSetup_form_blocks: "Blocs",
    setup_resourceSetup_form_blocks_btn1: "Bloquer la date/l'heure",
    setup_resourceSetup_form_blocks_btn2: "Créer",
    setup_resourceSetup_form_allocations_start_label: "Départ",
    setup_resourceSetup_form_allocations_end_label: "Fin",
    setup_resourceSetup_form_allocations_from_label: "Depuis",
    setup_resourceSetup_form_allocations_to_label: "À",
    setup_resourceSetup_form_allocations_repeat_label: "Répéter",
    setup_resourceSetup_form_allocations_repeats_label: "Répétitions",
    setup_resourceSetup_form_allocations_every_label: "Chaque",
    setup_resourceSetup_form_allocations_on_label: "Sur",
    setup_resourceSetup_form_allocations_daily_label: "Tous les jours",
    setup_resourceSetup_form_allocations_weekly_label: "Hebdomadaire",
    setup_resourceSetup_form_allocations_monthly_label: "Mensuel",
    setup_serviceSetup_confirmation: "Votre service a été configuré avec succès.",
    setup_serviceSetup_title: "Service de configuration",
    setup_serviceSetup_form_name: "Nom du service",
    setup_serviceSetup_form_type: "Taper",
    setup_serviceSetup_form_duration: "Durée",
    setup_serviceSetup_form_feeAmount: "Montant des frais",
    setup_serviceSetup_form_variableDuration: "Durée variable",
    setup_serviceSetup_form_durationMin: "Durée minimale",
    setup_serviceSetup_form_durationMax: "Durée maximale",
    setup_serviceSetup_form_durationInterval: "Intervalle de durée",
    no_language: "Désolé, la traduction pour cette langue n’existe pas encore.",
    allocation_item_repeats_D: 'Tous les jours',
    allocation_item_repeats_W: 'Hebdomadaire',
    allocation_item_repeats_M: 'Mensuel',
  },
  de: {
    error: "Leider ist etwas schiefgelaufen.",
    utility_with: "mit",
    utility_to: "bis",
    utility_save: "Speichern",
    utility_cancel: "Abbrechen",
    consumer_locations_title: "Standort auswählen",
    consumer_location_title: "Standort anzeigen",
    consumer_services_title: "Dienst auswählen",
    consumer_resources_title: "Ressource auswählen",
    consumer_appointments_title: "Termin auswählen",
    consumer_search_locations: "Standorte suchen...",
    consumer_search_services: "Dienste suchen...",
    consumer_search_resources: "Ressourcen suchen...",
    consumer_search_appointments: "Termine suchen...",
    consumer_availability_none: "Leider ist für diesen Zeitraum kein Termin verfügbar.",
    consumer_availability_title: "Datum und Uhrzeit auswählen",
    consumer_availability_month_jan: "Januar",
    consumer_availability_month_feb: "Februar",
    consumer_availability_month_mar: "März",
    consumer_availability_month_apr: "April",
    consumer_availability_month_may: "Mai",
    consumer_availability_month_jun: "Juni",
    consumer_availability_month_jul: "Juli",
    consumer_availability_month_aug: "August",
    consumer_availability_month_sep: "September",
    consumer_availability_month_oct: "Oktober",
    consumer_availability_month_nov: "November",
    consumer_availability_month_dec: "Dezember",
    consumer_availability_weekday_sun: "Sonntag",
    consumer_availability_weekday_mon: "Montag",
    consumer_availability_weekday_tue: "Dienstag",
    consumer_availability_weekday_wed: "Mittwoch",
    consumer_availability_weekday_thu: "Donnerstag",
    consumer_availability_weekday_fri: "Freitag",
    consumer_availability_weekday_sat: "Samstag",
    consumer_availability_time_of_day_morning: "Morgen",
    consumer_availability_time_of_day_afternoon: "Nachmittag",
    consumer_availability_time_of_day_evening: "Abend",
    consumer_availability_booking_form_title: "Buchung abschließen",
    consumer_availability_booking_form_expired: "Der Termin ist abgelaufen, bitte wählen Sie eine neue Uhrzeit aus.",
    consumer_availability_booking_form_expiration: "läuft ab in",
    consumer_availability_booking_form_minutes: "Minuten",
    consumer_availability_booking_form_firstName: "Vorname",
    consumer_availability_booking_form_lastName: "Nachname",
    consumer_availability_booking_form_email: "E-Mail",
    consumer_availability_booking_form_phone: "Telefon",
    consumer_availability_booking_form_customerMessage: "Hinterlassen Sie eine Nachricht",
    consumer_availability_booking_form_submit: "Senden",
    consumer_availability_booking_form_cancel: "Abbrechen",
    consumer_availability_booking_form_confirmation: "Ihr Termin wurde gebucht.",
    consumer_availability_booking_form_reschedule_confirmation: "Ihr Termin wurde verschoben.",
    consumer_availability_booking_form_sms: "Benachrichtigen Sie mich per SMS",
    consumer_appointment_detail: "{serviceName} mit {resourceName}",
    consumer_appointment_duration: "{duration} min",
    location_title: "Standort anzeigen",
    location_not_found: "Es wurde kein Standort gefunden.",
    setup_locationSetup_title: "Standort einrichten",
    setup_locationSetup_confirmation: "Ihr Standort wurde erfolgreich eingerichtet.",
    setup_locationSetup_form_name: "Standortname",
    setup_locationSetup_form_timezone: "Zeitzone",
    setup_locationSetup_form_book: "Buchen",
    setup_locationSetup_form_addressLine1: "Adresse",
    setup_locationSetup_form_addressLine2: "Adresszeile 2",
    setup_locationSetup_form_email: "E-Mail",
    setup_locationSetup_form_website: "Website",
    setup_locationSetup_form_city: "Stadt",
    setup_locationSetup_form_state: "Bundesland/Provinz",
    setup_locationSetup_form_postalCode: "PLZ",
    setup_locationSetup_form_bookAheadUnit: "Vorab buchen",
    setup_locationSetup_form_bookAheadValue: "Voraus buchen",
    setup_locationSetup_form_bookInAdvance: "Voraus buchen",
    setup_locationSetup_form_availability: "Verfügbarkeit",
    setup_locationSetup_form_blocks: "Blöcke",
    setup_locationSetup_form_blocks_btn1: "Datums-/Zeitblock hinzufügen",
    setup_locationSetup_form_allocations_btn1: "Verfügbares Datum/Uhrzeit hinzufügen",
    setup_locationSetup_form_allocations_btn1_desc: "Offene Verfügbarkeit für ein bestimmtes Datum und eine bestimmte Uhrzeit, die bis zu einem angegebenen Enddatum wiederholt werden kann",
    setup_locationSetup_form_blocks_btn2: "Erstellen",
    setup_resourceSetup_title: "Ressource einrichten",
    setup_resourceSetup_confirmation: "Ihre Ressource wurde erfolgreich eingerichtet",
    setup_resourceSetup_form_name: "Ressourcenname",
    setup_resourceSetup_form_timezone: "Zeitzone",
    setup_resourceSetup_form_groupId: "Gruppe",
    setup_resourceSetup_form_addressLine1: "Adresse",
    setup_resourceSetup_form_addressLine2: "Adresszeile 2",
    setup_resourceSetup_form_email: "E-Mail",
    setup_resourceSetup_form_website: "Website",
    setup_resourceSetup_form_city: "Stadt",
    setup_resourceSetup_form_state: "Bundesland/Provinz",
    setup_resourceSetup_form_select_state: "Bundesland/Provinz auswählen",
    setup_resourceSetup_form_country: "Land",
    setup_resourceSetup_form_select_country: "Land",
    setup_resourceSetup_form_postalCode: "PLZ/Postleitzahl",
    setup_resourceSetup_form_conferenceInfo: "Konferenzinfo",
    setup_resourceSetup_form_bookAheadUnit: "Vorab buchen",
    setup_resourceSetup_form_bookAheadValue: "Vorher buchen",
    setup_resourceSetup_form_bookInAdvance: "Vorher buchen",
    setup_resourceSetup_form_availability: "Verfügbarkeit",
    setup_resourceSetup_form_blocks: "Blöcke",
    setup_resourceSetup_form_blocks_btn1: "Blockdatum/-zeit",
    setup_resourceSetup_form_blocks_btn2: "Erstellen",
    setup_resourceSetup_form_allocations_start_label: "Beginn",
    setup_resourceSetup_form_allocations_end_label: "Ende",
    setup_resourceSetup_form_allocations_from_label: "Von",
    setup_resourceSetup_form_allocations_to_label: "Bis",
    setup_resourceSetup_form_allocations_repeat_label: "Wiederholen",
    setup_resourceSetup_form_allocations_repeats_label: "Wiederholt",
    setup_resourceSetup_form_allocations_every_label: "Jeden",
    setup_resourceSetup_form_allocations_on_label: "Ein",
    setup_resourceSetup_form_allocations_daily_label: "Täglich",
    setup_resourceSetup_form_allocations_weekly_label: "Wöchentlich",
    setup_resourceSetup_form_allocations_monthly_label: "Monatlich",
    setup_serviceSetup_confirmation: "Ihr Service wurde erfolgreich eingerichtet.",
    setup_serviceSetup_title: "Service einrichten",
    setup_serviceSetup_form_name: "Servicename",
    setup_serviceSetup_form_type: "Typ",
    setup_serviceSetup_form_duration: "Dauer",
    setup_serviceSetup_form_feeAmount: "Gebührenbetrag",
    setup_serviceSetup_form_variableDuration: "Variable Dauer",
    setup_serviceSetup_form_durationMin: "Minimale Dauer",
    setup_serviceSetup_form_durationMax: "Maximale Dauer",
    setup_serviceSetup_form_durationInterval: "Dauerintervall",
    no_language: "Leider existiert noch keine Übersetzung für diese Sprache.",
    allocation_item_repeats_D: 'Täglich',
    allocation_item_repeats_W: 'Wöchentlich',
    allocation_item_repeats_M: 'Monatlich',
  }
}

const InitInternationalization = (element) => {
  let language = element.onsched.language;
  
  if (element.onsched.detectLocale) {
    language = navigator.language.slice(0,2);
  }
  
  let messages = languages[language];

  if (!messages) {
    Toast(element, { error: true, message: languages[element.onsched.language ? element.onsched.language : "en"].no_language })

    if (element.onsched.detectLocale && element.onsched.language) {
      messages = languages[element.onsched.language];
    }
  }
  
  const cache = createIntlCache()
  
  const intl = createIntl(
    {
      locale: language,
      defaultLocale: element.onsched.language ? element.onsched.language : "en",
      messages,
    },
    cache
  )
  
  return intl
}

export const Internationalize = (element, id) => {
  return InitInternationalization(element).formatMessage({ id, defaultMessage: languages.en[id] })
}
